<style lang="scss">
.brand-item {
  padding: 10px;
  .bgk {
    margin-top: 10px;
    height: 140px;
    background: #000;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    .el-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .ft {
    text-align: right;
    font-size: 12px;
    color: $color-hint-text;
    margin-top: 10px;
  }
  .label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }
}
.group-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .label {
    font-size: 13px;
  }
}
</style>
<template>
  <div class="brand-item">
    <div class="group-btn">
      <span>{{ value.label }}</span>
      <el-radio-group
        v-model="value.type"
        size="small"
        @change="handleClickType"
      >
        <el-radio-button :label="1">
          默认
        </el-radio-button>
        <el-radio-button :label="2">
          自定义
        </el-radio-button>
      </el-radio-group>
    </div>

    <div
      class="bgk"
      :style="{ backgroundImage: `url(${value.type == 1 ? value.defaultMenusImg : value.img})` }"
    >
      <el-button
        v-if="value.type == 2"
        type="primary"
        size="small"
        @click="handleClickChangeImage"
      >
        替换图片
      </el-button>
    </div>
    <div class="ft">
      建议尺寸750px*400px
    </div>

    <SpImageSelect
      :image-visible="showImgPicker"
      :choose-one="true"
      @closeImageDialog="onClosePicker"
      @chooseImage="onChangePicker"
    />
  </div>
</template>

<script>
export default {
  name: 'BrandItem',
  components: {},
  props: {
    value: Object
  },
  data () {
    return {
      showImgPicker: false
    }
  },
  created () {},
  mounted () {
    console.log('BrandItem-value', this.value)
    this.value.type = +this.value.type
  },
  methods: {
    handleClickChangeImage () {
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    handleClickType (val) {
      console.log('[handleClickType]-val', val)
      console.log('[handleClickType]-value', this.value)
      // this.$emit('input', this.value)
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        // this.value.img = data[0].image_url
        this.$set(this.value, 'img', data[0].image_url)
      }
      this.$emit('input', this.value)
    }
  }
}
</script>
